import { render, staticRenderFns } from "./CommunityPopupNotice.vue?vue&type=template&id=3eef5329&scoped=true"
import script from "./CommunityPopupNotice.vue?vue&type=script&lang=js"
export * from "./CommunityPopupNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eef5329",
  null
  
)

export default component.exports